import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { ChatbotButton, IChatbotButton } from './ChatbotButton';

interface IChatbotButtonPeriodicity extends IChatbotButton {
  isActive?: boolean;
}

export const ChatbotButtonPeriodicity = ({ isActive, ...rest }: IChatbotButtonPeriodicity) => (
  <ChatbotButton
    theme={isActive ? 'fill_primary' : 'fill_white_primary'}
    beforeIcon={isActive ? <IconFunctionalSuccess16 color={'icon-inverted-default'} /> : undefined}
    {...rest}
  />
);
